import React, { Component } from "react";
import "./studentActivity.scss";
import { Toast, WhiteSpace, WingBlank, Button, Tag } from "antd-mobile";
import axios from "../axios";

var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

class studentActivity extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            selectImageId : '',
            userId : "",
            showBigImage : false,
            dataList :[
                {
                    title_p : "真实姓名:",
                    placeholder :"请输入您的真实姓名",
                    tagId :"XM",
                    account : "",
                },
                {
                    title_p : "学校名称:",
                    placeholder : "请输入您的学校全称",
                    tagId :"XXMC",
                    account : "",
                },
                {
                    title_p : "学生证封面照:",
                    placeholder : "请上传学生证封面照片",
                    tagId :"XSZFM",
                    example_img: "http://image.ybk008.com/student_fm_image.jpg",
                    imageUrl: "",
                },
                {
                    title_p : "学生证第一页展开照:",
                    placeholder : "请上传学生证第一页展开照片",
                    tagId :"XSZSY",
                    example_img: "http://image.ybk008.com/studentfirstpage.jpg",
                    imageUrl: "",
                },
            ],  
        };
    }

     getUrlParam = (name) => {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = this.props.location.search.substr(1).match(reg);
        if (r != null) {
          return decodeURI(r[2]);
        }
        return ""; //如果此处只写return;则返回的是undefined
    };

    addShiliImage = (imageId) =>{//查看示例图

        let dataList = this.state.dataList;
        for (let i = 0; i < dataList.length; i++) {
            const element = dataList[i];
            if (element.tagId === imageId) {
                this.setState({
                    showBigImage : true,
                    bigImage : element.example_img,
                });
                return;
            }  
        
        }
    }

    addImage =(imageId) =>{//上传图片和查看大图

        let dataList = this.state.dataList;
        for (let i = 0; i < dataList.length; i++) {
            const element = dataList[i];
            if (element.tagId === imageId && element.imageUrl.length) {
                this.setState({
                    showBigImage : true,
                    bigImage : element.imageUrl,
                });
                return;
            }  
        }

        var ua = navigator.userAgent.toLowerCase();
        var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";
        if (isApp) {
            if (isiOS) {
                try {
                    window.webkit.messageHandlers.IOSNativePhotoImage.postMessage('1');
                } catch (e) {
                }
            }else{
                try {
                    window.app.androidNativePhotoImage(1);
                } catch (e) {
                }
            }
        }

        this.setState({
            selectImageId : imageId,
        });

    };

    IOSPhotoImageUpload = (val) => {//图片回调

        let imageUrl = "";
        if (isiOS) {
            JSON.parse(val).map((item, key) => {
                imageUrl = item;
            });
        } else {
            val.split(",").map((item, key) => {
                imageUrl = item;
            });
        }

        let dataList = this.state.dataList;
        for (let i = 0; i < dataList.length; i++) {
            const element = dataList[i];
            if (element.tagId === this.state.selectImageId) {
                element.imageUrl = imageUrl;
            }  
        }
        this.setState({
            dataList : dataList,
        });
        console.log(this.state.dataList);
    };

    closeBigImage =() =>{
        this.setState({
            showBigImage : false,
            bigImage : "",
        });
    };

    removeImage =(imageId) =>{
        let dataList = this.state.dataList;
        for (let i = 0; i < dataList.length; i++) {
            const element = dataList[i];
            if (element.tagId === imageId) {
                element.imageUrl = "";
            }  
        }
        this.setState({
            dataList : dataList,
        });
    };

    loadingRequestdata = () =>{
        var i = 0;
        var collegeName,stdtName,cardCover,cardImage;
        let dataList = this.state.dataList;
        for (let i = 0; i < dataList.length; i++) {
            const element = dataList[i];
            switch (element.tagId) {
                case 'XM':
                    if (!element.account.length) {
                        Toast.show(element.placeholder, 2);
                        return;
                    }
                    stdtName = element.account; 
                    break;

                case 'XXMC':
                    if (!element.account.length) {
                        Toast.show(element.placeholder, 2);
                        return;
                    }
                    collegeName = element.account;
                    break;

                case 'XSZFM':
                    if (!element.imageUrl.length) {
                        Toast.show(element.placeholder, 2);
                        return;
                    }
                    cardCover = element.imageUrl;
                    break;
            
                case 'XSZSY':
                    if (!element.imageUrl.length) {
                        Toast.show(element.placeholder, 2);
                        return;
                    }
                    cardImage = element.imageUrl;
                    break;

                default:
                    break;
            }
        }
        const _this = this;
        axios
         .post("fbusiness/json/saveStudentActivityInfo",{userId : _this.state.userId, stdtName : stdtName, collegeName : collegeName, cardCover : cardCover, cardImage : cardImage})
         .then(function (response){
            if (response.data.code === 10000) {
                  Toast.show("提交成功", 2);
                  setTimeout(() => {
                    _this.goToBack();
                }, 1500);
            }else {
               let message = response.data.message;
               Toast.show(message, 2);
            }  
         })
         .catch(function (error) {
            console.log(error);
         });
    };

    goToBack = () =>{
        var ua = navigator.userAgent.toLowerCase();
        var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";
        if (isApp) {
            if (isiOS) {
                try {
                    window.webkit.messageHandlers.IOSNativeGotoBack.postMessage("");
                } catch (e) {
                }
            }else{
                try {
                    window.app.androidNativeGotoBack();
                } catch (e) {
                }
            }
        } 
    };

    componentDidMount (){
        sessionStorage.setItem("Authorization", this.getUrlParam('tokenHead') + ' ' + this.getUrlParam('tokenCode'));
        sessionStorage.setItem("cAppVersion", this.getUrlParam('v'));
        let userId = this.getUrlParam('userId');
        this.setState({
            userId : userId,
        });
        // funcitonName 是原生回调使用的方法名
        window["IOSPhotoImageUpload"] = this.IOSPhotoImageUpload.bind(this);
    }

    inputAccounts = (ev) => {
        var value = ev.target.value;
        if (value.length) {
            if (value.length > 20) {
                Toast.show("最多只能输入20个", 2);
                return;
            }
        }
        let dataList = this.state.dataList;
        for (let i = 0; i < dataList.length; i++) {
            const element = dataList[i];
            if (element.tagId === ev.target.id) {
                element.account = value;
            }
        }
        this.setState({
            dataList : dataList,
        })
        
    };

    render() {
        return (
            <div className="studentActivity_div">
                {this.state.showBigImage ? (
                    <div className="showBigimage_div" onClick={() => this.closeBigImage()}>
                        <img className="showBigImage_img" src={this.state.bigImage}></img>
                    </div>
                ) : null}
                <main>
                    <div className="studentContent_div">

                        {this.state.dataList.map((item, key) =>(
                            <div className="title_div">
                                <p className="title_p">{item.title_p}</p>
                                {item.tagId === 'XSZFM' || item.tagId === 'XSZSY'  ? 
                                    <div className="shortVideoImg_div">
                                        <div className="addScreenshotphoto_div">
                                            <img className="addScreenshot_img" src={item.imageUrl.length > 0 ? (item.imageUrl) : require("../assets/studentUpload@2x.png")} onClick={() =>this.addImage(item.tagId)}/>
                                            {item.imageUrl.length > 0 ? (<img className="delete_img" src={require("../assets/icon-delete.png")} onClick={() =>this.removeImage(item.tagId)}/>) : null}
                                        </div>
                                        <img className="example_img" src={item.tagId === 'XSZFM' ? require("../assets/studentZFM.png"): require("../assets/studentSLT@2x.png")} onClick={() =>this.addShiliImage(item.tagId)}/>
                                    </div>
                                :
                                  <input id={item.tagId} className="number_input" placeholder={item.placeholder} onChange={(ev) => this.inputAccounts(ev)} value={item.account}/>   
                                }
                                
                            </div>
                        ))}

                        <div className="prompt_div">
                            <img className="prompt_img" src="http://image.ybk008.com/studentPromptImage.png"></img>
                        </div>

                    </div>
                </main>
                <div className="seat_div" ></div>
                <button className="confirm_button" onClick={() =>this.loadingRequestdata()}>确认提交</button>

           </div>
        );   
    };

}

export default studentActivity;